module.exports = __webpack_public_path__ + "img/2-4.96e4c98c.jpg";